import PaymentWalletModal from './PaymentWalletModal';

export default PaymentWalletModal;